import { constants } from 'helpers';
import { ruleRunner } from 'validations/ruleRunner';
import {
  required,
  minLength,
  maxLength,
  arrayMinLength,
  isEmail,
  minimun,
  ruleIf,
  ruleIfValue,
  ruleIfNotValue,
  ruleIfInArray,
  plainText,
  maximum,
  ruleNotIf,
  supportEmailNotEduzzUnlessUserIsEduzz
} from 'validations/rules';

const Validations = [
  ruleRunner('title', 'título', required, maxLength(255)),
  ruleRunner(
    'description',
    'descrição',
    required,
    ruleIfValue('type', constants.TICKET, minLength(50)),
    ruleIfInArray('type', [constants.INFO, constants.PHYSICAL], minLength(100)),
    ruleIfValue('type', constants.SERVICE, plainText(4000)),
    ruleIfNotValue('type', constants.SERVICE, maxLength(4000))
  ),
  ruleRunner(
    'support_email',
    'E-mail de suporte',
    isEmail,
    ruleNotIf('has_children', required),
    supportEmailNotEduzzUnlessUserIsEduzz
  ),
  ruleRunner('image_id', 'imagem', ruleIfNotValue('cnt_partner_cod', constants.ALUMY, required)),
  ruleRunner('categories', 'categorias', arrayMinLength(1)),
  ruleRunner('refund_days', 'prazo para reembolso', required, minimun(7), maximum(30)),
  ruleRunner('expiration_date', 'data de expiração', ruleIf('has_expiration_date', required)),
  ruleRunner('launch_date', 'data de lançamento', ruleIf('prelaunch', required)),
  ruleRunner('program_content', 'o que contém o seu produto', maxLength(4000))
];

export default Validations;
